import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * POST
 * /api/search/stations
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Returns all station info within passed in Geo Box
 */
export const searchChargingStations = (page = 0, pageSize = 20) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations?page=${page}&size=${pageSize}`,
        null,
        config
      )
      .then((resp) => {
        console.log("searchChargingStations", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/stations/full
 * ?openAlerts={openAlerts: boolean}
 * &page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Searches for charging stations
 */
export const searchChargingStationsFull = (
  showOpenAlerts = false,
  page = 0,
  pageSize = 20
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations/full?openAlerts=${showOpenAlerts}&page=${page}&size=${pageSize}`,
        null,
        config
      )
      .then((resp) => {
        console.log("searchChargingStationsFull", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/stations/full/distance
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Returns all station full info within passed in distance from request lat lon
 */
export const searchChargingStationsFullByDistance = (
  page = 0,
  pageSize = 20,
  data
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations/full/distance?page=${page}&size=${pageSize}`,
        data,
        config
      )
      .then((resp) => {
        console.log("searchChargingStationsByDistance", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/stations/full/bounded
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Returns all station full info within passed in Geo Box
 */
export const searchChargingStationsFullByGeoBox = (
  page = 0,
  pageSize = 20,
  data
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations/bounded?page=${page}&size=${pageSize}`,
        data,
        config
      )
      .then((resp) => {
        console.log("searchChargingStationsByGeoBox", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/stations/distance
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Returns all station info within passed in distance from request lat lon
 */
export const searchChargingStationsByDistance = (
  page = 0,
  pageSize = 20,
  data
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations/distance?page=${page}&size=${pageSize}`,
        data,
        config
      )
      .then((resp) => {
        console.log("searchChargingStationsByDistance", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/stations/bounded
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 *
 * Returns all station info within passed in Geo Box
 */
export const searchChargingStationsByGeoBox = (
  page = 0,
  pageSize = 20,
  data
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/stations/bounded?page=${page}&size=${pageSize}`,
        data,
        config
      )
      .then((resp) => {
        console.log("searchChargingStationsByGeoBox", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * POST
 * /api/search/alerts
 * ?page={page: integer($int32)}
 * &size={pageSize: integer($int32)}
 * &sortBy={sortBy: string}
 * &direction={sortDirection: string}
 *
 * Returns all alert info for org
 */
export const searchAlerts = (
  page = 0,
  pageSize = 25,
  sortBy = "reportedAt",
  sortDirection = "ASC",
  data = {}
) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .post(
        `${basePath}/search/alerts?page=${page}&size=${pageSize}&sortBy=${sortBy}&direction=${sortDirection}`,
        data,
        config
      )
      .then((resp) => {
        console.log("searchAlerts", resp);
        resolve(resp);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
